module.exports = __webpack_public_path__ + "static/las-374340a4c10cb4eb44672bd9a952794e.jpg";